import { Tooltip } from '@material-ui/core'
import { Help } from '@material-ui/icons'

import styles from './styles.module.scss'

const ToolTip = ({ text, arrow, ...rest }) => (
  <div className={styles.tooltipContainer}>
    <Tooltip className={styles.tooltipIcon} title={text} placement="top" disableTouchListener arrow={arrow} {...rest}>
      <Help className="toolTipIcon" style={{ color: '#6b6c72' }} />
    </Tooltip>
  </div>
)

ToolTip.defaultProps = {
  text: undefined,
}

export default ToolTip
